<div class="card-wrapper">
  <ion-card>
    <ion-card-header>
      <img src="../../../assets/images/sademo.png" />
      <h4>{{ "ongoing-warning.wantToLeave" | translate }} {{ data?.syndicate?.syndicate_name }}?</h4>
    </ion-card-header>
    <ion-card-content>
      <div>
        <p>{{ "ongoing-warning.benifits" | translate }}</p>
        <p><span class="dot">·</span><strong>{{ "ongoing-warning.automaticEntery" | translate }}</strong> {{ "ongoing-warning.everyDraw" | translate }}</p>
        <p><span class="dot">·</span><strong>{{ "ongoing-warning.One-off" | translate }}</strong> {{ "ongoing-warning.lotteryPurchases" | translate }}</p>
        <p>{{ "ongoing-warning.smartWay" | translate }} <br /><strong>>{{ "ongoing-warning.moreLines" | translate }}</strong></p>
      </div>
      <ion-button class="purple-btn" (click)="leaveSyndicate()">{{ "ongoing-warning.leave" | translate }}</ion-button>
      <p class="sub-link" (click)="close()">{{ "ongoing-warning.keepPlaying" | translate }}</p>
    </ion-card-content>
  </ion-card>
</div>
